<template>
  <div>
    <v-dialog v-if="is_show_dialog" v-model="is_show_dialog" max-width="1000" persistent @close="cancel()">

      <v-card elevation="24" class="border-radius" v-if="info == false">
        <v-card-text style="background:#FAFAFA">
          <div class="wizard-tab-content">
            <div role="tabpanel" id="choixListeContratDesktop" aria-hidden="true"
              aria-labelledby="step-choixListeContratDesktop" class="wizard-tab-container">
              <div>
                <div class="loan-group loan-group-0">
                  <div class="fields">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="field-title font-weight-bold">{{ $t('espace_perso.parrainage.parrainage_titre') }}
                        </div>

                      </div>
                      <!-- <div class="col-sm-6" v-if="coupon_parrainage">
                        <span v-if="coupon_parrainage.type = 'pourcentage'"
                          style="font-weight: 500;font-size: 15px;float: right;">{{ $t('espace_perso.parrainage.parrainage_bonus_text[0]') }} {{ coupon_parrainage.reduction }} {{ $t('espace_perso.parrainage.parrainage_bonus_text[1]') }}</span>
                        <span v-else style="font-weight: 500;font-size: 15px;float: right;">{{ $t('espace_perso.parrainage.parrainage_bonus_text[0]') }} {{ coupon_parrainage.reduction }} {{ $t('espace_perso.parrainage.parrainage_bonus_text[2]') }}</span>
                      </div> -->

                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="field-group field-default mt-3">
                          <!-- <h4>Parrainé un numéro</h4> -->
                          <label for="parrainage_number" class="field-label">{{ $t('espace_perso.parrainage.parrainage_number') }}</label>
                          <input id="parrainage_number" v-model="phone_number" :placeholder="$t('espace_perso.parrainage.parrainage_number_placeholder')" class="field-input">
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="wizard-card-footer clearfix">
                          <div class="wizard-footer-right">
                            <button @click="add_parrainer()" type="button" class="wizard-btn">
                              {{ $t('espace_perso.parrainage.parrainage_add_label') }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-sm-6">
                        <!-- <div class="field-group field-default mt-3">
                          <input v-model="lien_parrain" class="field-input">
                        </div> -->
                        <p>{{ lien_parrain }} <button @click="copyToClipboard" class="btn"><i class="material-icons" aria-hidden="true" data-nosnippet>&#xe14d;</i></button>
                          <span class="copy--area">Copier</span></p>
                      </div>
                      <!-- <div class="col-sm-4">
                        <div style="margin-top: 20px;">
                            <button @click="copyToClipboard" class="btn"><i class="material-icons" aria-hidden="true" data-nosnippet>&#xe14d;</i></button>
                                <span class="copy--area">Copier</span>
                        </div>
                      </div> -->
                      <!-- <div class="field-group field-default mb-4 mb-sm-0">
                            <p>Grâce à votre parrain, vous bénéficiez d’une réduction de <br> {{ coupon_parrainage }}% sur votre 1er contrat Assuraf</p>
                        </div> -->
                      <!-- <div class="field-group field-default mb-4 mb-sm-0" v-if="coupon_parrainage">
                            <p>Grâce à votre parrain, vous bénéficiez d’une réduction de <br> {{ coupon_parrainage }}% sur votre 1er contrat Assuraf</p>
                        </div> -->
                    </div>
                    <div class="row" style="z-index:10000">
                      <v-data-table class="mt-3 fb-table-elem ml-3"
                        :headers="$t('espace_perso.parrainage.headerContrat')" :items="user_parrainages" expand
                        style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);width: 100%">
                        <template slot="items" slot-scope="props">
                          <tr>
                            <td class="text-xs-left">
                              <div class="datatable-cell-wrapper">{{ DateFormater(props.item.created) }}</div>
                            </td>
                            <!-- <td class="text-xs-left">
                                <div class="datatable-cell-wrapper">{{ props.item.code_parrain }}</div>
                              </td> -->
                            <td class="text-xs-left">
                              <div class="datatable-cell-wrapper">{{ props.item.phone_parrainer }}</div>
                            </td>
                            <td class="text-xs-left">
                              <div class="datatable-cell-wrapper">
                                <v-chip v-if="props.item.status_parrain == 'initial'" variant="text" density="compact"
                                  size="small">
                                  {{ props.item.status_parrain }}
                                </v-chip>
                                <v-chip v-if="props.item.status_parrain == 'en attente'" variant="text" color="warning"
                                  density="compact" size="small">
                                  {{ props.item.status_parrain }}
                                </v-chip>
                                <v-chip v-if="props.item.status_parrain == 'active'" variant="text" color="success"
                                  density="compact" size="small">
                                  {{ props.item.status_parrain }}
                                </v-chip>
                              </div>
                            </td>
                            <td class="text-xs-left">
                              <div class="datatable-cell-wrapper">{{ props.item.montant || 0 }} F FCFA</div>
                            </td>

                            <td class="text-xs-left justify-content-start row">
                              <div class="datatable-cell-wrapper">
                                <span class="tool_button" data-tip="Voir détails parrainage !" tabindex="1">
                                  <!-- <v-btn icon>
                                    <v-icon color="#ffa409" >&#xe8f4;</v-icon>
                                  </v-btn> -->
                                  <v-btn icon @click="show_parrainer(props.item)">
                                    <v-icon color="#ffa409" title="voir details">&#xe8f4;</v-icon>
                                  </v-btn>

                                  <v-btn icon @click="share_parrainer(props.item)">
                                    <v-icon color="#ffa409" title="Partager sur whatsapp">&#xe80d;</v-icon>
                                  </v-btn>
                                  <!-- <button @click="share_parrainer(props.item)"> share  </button> -->
                                </span>
                              </div>
                             
                            </td>

                          </tr>
                        </template>
                        <template v-slot:no-results>
                          <v-alert class="text-center" :value="true" color="error" icon="warning">{{
                            $t('espace_perso.contrat_list.found_or_not_label[0]') }}
                            "{{ searchContratDesktop + '=' }}"
                            {{ $t('espace_perso.contrat_list.found_or_not_label[1]') }}
                          </v-alert>
                        </template>
                      </v-data-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="wizard-card-footer clearfix">
            <div class="wizard-footer-left">
              <button @click="cancel()" type="button" class="wizard-btn">
                <span class="fas fa-arrow-left"></span>
                {{ $t('espace_perso.contrat_list.bouton_fermer_label') }}
              </button>
            </div>
            <div class="wizard-footer-right">
            </div>
          </div>
        </v-card-text>
      </v-card>
      <v-card elevation="24" class="border-radius" v-else>
        <v-card-text style="background:#FAFAFA">
          <div class="wizard-tab-content">
            <div role="tabpanel" id="choixListeContratDesktop" aria-hidden="true"
              aria-labelledby="step-choixListeContratDesktop" class="wizard-tab-container">
              <div>
                <div class="loan-group loan-group-0">
                  <div class="fields">
                    <div class="row"> 
                      <!-- <v-container class="border-radius">
                            <v-layout wrap>
                              <div class="col-sm-12">
                                {{ info_parrainage }}
                              </div>
                            </v-layout>
                          </v-container> -->

                         
                          <v-container class="border-radius">
                            <v-layout wrap>
                              <div class="col-sm-12">
                                 <div class="row border mt-2 pt-3 pb-3 mb-3" style="background:#fff;border-radius: 10px;">
                                   <div class="col-sm-4 font-weight-bold">
                                    Date de création :
                                    <span class="font-weight-light">{{ DateFormater(info_parrainage.created)}}</span>
                                  </div>
                                  <div class="col-sm-4 font-weight-bold">
                                    Plateforme :
                                    <span class="font-weight-light">{{ info_parrainage.plateforme
                                      }}</span>
                                  </div>
                                  <div class="col-sm-4 font-weight-bold">
                                    Status
                                    :
                                    <span class="font-weight-light">{{ info_parrainage.status_parrain }}</span>
                                  </div>
                                </div>
                                <div class="row border pt-3 pb-3" style="background:#fff;border-radius: 10px;">
                                  <div class="col-sm-4 font-weight-bold">
                                    Code parrain :
                                    <span class="font-weight-light">{{ info_parrainage.code_parrain}}</span>
                                  </div>
                                  <div class="col-sm-4 font-weight-bold">
                                    Numéro parrainé
                                    :
                                    <span class="font-weight-light">{{ info_parrainage.phone_parrainer }}</span>
                                  </div>
                                  <div class="col-sm-4 font-weight-bold">
                                    Montant:
                                    <span class="font-weight-light">{{ info_parrainage.montant.toLocaleString() }}
                                      FCFA</span>
                                  </div>
                                </div>
                              </div>
                            </v-layout>
                          </v-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="wizard-card-footer clearfix">
            <div class="wizard-footer-left">
              <button @click="cancel2()" type="button" class="wizard-btn">
                <span class="fas fa-arrow-left"></span>
                {{ $t('espace_perso.contrat_list.bouton_fermer_label') }}
              </button>
            </div>
            <div class="wizard-footer-right">
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "../../services/Api";
import store from "../../store/store";
import dayjs from "dayjs";
export default {
  name: "dashboard",
  props: {
    user_parrainages: Array,
    add_dialog: Boolean,
    coupon_parrainage: Object,
    lien_parrain: String,
  },
  computed: {
    is_show_dialog: {
      get() {
        return this.add_dialog;
      },
      set() {
        return false;
      }
    }
  },

  data() {
    return {
      info: false,
      info_parrainage: {},
      searchContratDesktop: "",
      phone_number: '',
      user_parrainages: [],
      nb_parrainer: 0,
      ToastTabSucess: {
        theme: "toasted-primary",
        position: "top-center",
        duration: 5000,
        fitToScreen: true,
        type: "success",
        className: "custom-success-class",
      },
      ToastTabError: {
        theme: "toasted-primary",
        position: "top-center",
        duration: 5000,
        fitToScreen: true,
        type: "error",
      },
      ToastTabWarning: {
        theme: "toasted-primary",
        position: "top-center",
        duration: 5000,
        fitToScreen: true,
        type: "info",
      }
    }
  },
  methods: {
    
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.lien_parrain);
        this.$toasted.show("Lien parrainage copié ! ", this.ToastTabSucess)
      } catch (err) {
        console.error("Erreur de copie :", err);
      }
    },
    share_parrainer(item){
      let text_pre_rempli = 'je vous invite sur Assuraf ! Profite d’une réduction sur ton 1er contrat. Inscris-toi ici 👉 '+this.lien_parrain
      let whatsappLink = `https://api.whatsapp.com/send?text=${encodeURIComponent(text_pre_rempli)}`;
      window.open(whatsappLink, '_blank');
    },
    show_parrainer(item){
      this.info = true
      this.info_parrainage = item
    },
    //Date object formater to String
    DateFormater: function (TheDate) {
      if (TheDate) {
        return dayjs(TheDate).format("DD-MM-YYYY");
      }
    },
    isValidPhoneNumber(num) {
      return /^\d{9,10}$/.test(num);
    },
    cancel() {
      this.phone_number = '',
        this.$emit('parrainage-add', { data: null })
    },
    cancel2() {
      this.info = false
    },
    add_parrainer() {
      if (this.phone_number == '') {
        this.$toasted.show("le numéro de téléphone est obligatoire !", this.ToastTabError);
        return;
      } else {
        if (!this.isValidPhoneNumber(this.phone_number) || this.phone_number.length < 9) {
          this.$toasted.show("le numéro de téléphone n'est pas valide !", this.ToastTabError);
          return;
        }
      }
      Api()
        .post("parrainages/add", {
          clientid: store.state.user._id,
          phone_parrainer: this.phone_number,
          plateforme: 'Front'
        }).then((response) => {
          if (response.data && response.data.code == 0) {
            this.phone_number = ''
            this.$toasted.show(response.data.message, this.ToastTabSucess)
            this.$emit('parrainage-add', { data: { ...response.data, dialog: true } })
          } else {
            if (response.data && response.data.code == 1) {
              this.$toasted.show(response.data.message, this.ToastTabWarning)
            } else {
              this.$toasted.show(JSON.stringify(response.data), this.ToastTabWarning);
            }
          }


        }).catch(error => {
          console.log('error => ', error)
          this.$toasted.show("Http Error !", this.ToastTabError);
        })
    },
  }
}
</script>

<style lang="less" scoped>
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 15px;
}



.copy--status--bubble .check-circle {
  background: #333;
  border-radius: 100%;
  height: 2rem;
  width: 2rem;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
          justify-content: center;
  -webkit-box-align: center;
          align-items: center;
  margin-right: 1rem;
}
.status--fade--in {
  -webkit-transform: translateX(0rem);
          transform: translateX(0rem);
  opacity: 1;
}
.btn {
  background: transparent;
  border: none;
  border-radius: 100%;
  cursor: pointer;
  position: relative;
  margin-right: -20px;
}
.btn:hover::after {
  content: "Copier";
  color: #000;
  background: #ffa409;
  padding: 0.3rem;
  border-radius: 0.5rem;
  position: absolute;
  left: 10%;
  top: -60%;
}
.text-area {
  margin-top: 4rem;
  display: -webkit-box;
  display: flex;
}
.pasteBtn {
  background: #111;
  color: #fff;
  border-radius: 0;
  padding: 0.5rem;
  margin: 0;
  top: 0;
  position: relative;
  border: none;
  cursor: pointer;
}
</style>